require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-2019-01-17-interior-iv.json") })
        }
      }, "path---works-2019-01-17-interior-iv");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-2019-01-17-interior-iv!./.cache/json/works-2019-01-17-interior-iv.json
// module id = 421
// module chunks = 231608221292675